export { default } from './UnscoredCategoryPageHero'
